angular.module('tasks')
    .component('taskStatusLabel', {
        bindings: {
            status: '<',
            flag: '<'
        },
        template: `
            <span ng-if="$ctrl.status && $ctrl.flag === true" class="task-status-label-{{$ctrl.status}} flag" title="{{ \'task.status.\'.concat($ctrl.status) | translate }}"><i class="flag fa fa-fw fa-font-awesome"></i></span>
            <span ng-if="$ctrl.status && !$ctrl.flag" class="label label-default task-status-label-{{$ctrl.status}}">{{ \'task.status.\'.concat($ctrl.status) | translate }}</span>
        `
    })
